import { Search } from 'lucide-react';
import { cn } from '@/lib/cn';

export type DeviceFilter = 'all' | 'online' | 'offline' | 'expiring';

interface Props {
  query: string; onQueryChange: (q: string) => void;
  filter: DeviceFilter; onFilterChange: (f: DeviceFilter) => void;
  counts: Record<DeviceFilter, number>;
}

const tabs: Array<{ id: DeviceFilter; label: string }> = [
  { id: 'all',      label: 'All' },
  { id: 'online',   label: 'Online' },
  { id: 'offline',  label: 'Offline' },
  { id: 'expiring', label: 'Expiring' },
];

export function DeviceFilters({ query, onQueryChange, filter, onFilterChange, counts }: Props) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 sm:items-center mb-5">
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search by name or client id"
          className="w-full h-10 pl-9 pr-3 rounded-lg border border-slate-300 bg-white text-sm focus:border-ink"
        />
      </div>
      <div className="flex items-center gap-1 bg-white border border-slate-200 rounded-lg p-1">
        {tabs.map((t) => (
          <button
            key={t.id}
            onClick={() => onFilterChange(t.id)}
            className={cn(
              'px-3 py-1.5 rounded-md text-xs font-semibold transition-colors',
              filter === t.id
                ? 'bg-ink text-white'
                : 'text-slate-600 hover:bg-slate-100',
            )}
          >
            {t.label}
            <span className={cn('ml-1.5', filter === t.id ? 'text-white/70' : 'text-slate-400')}>
              {counts[t.id]}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
